export const actionTypes = {
    SET_WIDTH: "SET_WIDTH",
    SET_MODE: "SET_MODE",
}